import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket/store'
import { type IResponseCallHoldConfirmed } from 'entities/Call/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

// Backend pusher event: customer was successfully parked in the hold queue.
// Frontend already set isHold=true optimistically after the /voice/call/hold
// API response; this upgrades the entry to confirmed-held state, which the UI
// may surface for tooltips or "held by you for 1m12s" badges later.
export const useEventCallHoldConfirmed = () => {
  const { websocket, callStore } = useEntitiesContext()

  const handle = (data: IResponseCallHoldConfirmed) => {
    callStore.markHoldConfirmed(data.call_sid)
  }

  useEffect(() => websocket.on(WebsocketEvent.CallHoldConfirmed, handle), [])
}
